export default "__VITE_ASSET__94bmFChj__"